import type { ReactNode } from 'react'

import { cn } from '@/lib/utils'
import Sparkline from '@/components/charts/sparkline'

interface StatTileProps {
    label: ReactNode
    value: ReactNode
    delta?: ReactNode
    hint?: ReactNode
    trend?: number[]
    className?: string
}

const StatTile = ({ label, value, delta, hint, trend, className }: StatTileProps): ReactNode => {
    return (
        <div className={cn('flex min-w-0 flex-col justify-between gap-2 rounded-xl border border-border bg-card px-4 py-3.5', className)}>
            <p className='truncate text-xs font-medium text-muted-foreground'>{label}</p>

            <div className='flex items-end justify-between gap-3'>
                <div className='min-w-0'>
                    <p className='truncate text-xl font-semibold tracking-tight text-foreground'>{value}</p>
                    {delta && <div className='mt-0.5 text-xs'>{delta}</div>}
                    {hint && <p className='mt-0.5 truncate text-[11px] text-muted-foreground'>{hint}</p>}
                </div>

                {trend && trend.length > 1 && <Sparkline values={trend} width={84} height={30} tone='flat' className='opacity-80' />}
            </div>
        </div>
    )
}

export default StatTile
